  
<template>
    <div class="know">
        <div class="head">  
            <h1>易小淘 视频</h1>
        </div>
        <v-vid></v-vid>
    </div>
</template>

<script>
export default {
   data(){
    return{

    }
   },
   created(){
     
   },
   methods:{

   }
}
</script>

<style lang="less" scped>
.know{
    background: #F5F5F5;
    width: 100%;
    // min-height: 100vh;
   .head{
    width: 100%;
    height: 1rem;
    // background: #999;
    position: fixed;
    left: 0;
    top: 0;
    background-size: 100% 100%;
    h1{
      font-size: 0.4rem;
      color: #333;
      margin-top: 0.2rem;
      padding-left: 0.32rem
    }
    
   }
}
</style>


// WEBPACK FOOTER //
// src/modules/videoList.vue